import { combineReducers } from 'redux';
import { things } from './things';

// combine all reducers to one global reducer
// executed once at startup
export default combineReducers({
    things
});
